<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import InputBox from '../../components/InputBox.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';

// This is Q19 is used only for call survey.
export default defineComponent({
  name: 'SurveyQ19',
  components: {
    InputBox,
    Button: SolutoButton
  },
  computed: {
    ...mapGetters([
      'deviceSupportNeeds'
    ])
  },
  methods: {
    ...mapActions([
      'changeDeviceSupportNeeds'
    ]),
    saveText (event: string) {
      this.changeDeviceSupportNeeds(event);
    },
    nextScreen () {
      router.push({ path: '/survey/question20/' });
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q2">
        <p class="with-margin">{{ $t('survey_19') }}</p>
        <input-box @change="saveText" :text="deviceSupportNeeds"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
